export default __webpack_public_path__ + "static/media/ic_collaborate.926378a2.webp";